import { Stack, Typography } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import LegendTable from './LegendTable';

const Legends = ({ legends }) => {
  console.log(legends, 'legends');
  const intl = useIntl();
  return (
    <Stack maxHeight="65vh">
      <Typography variant="h4">
        <FormattedMessage defaultMessage="Legend" />
      </Typography>
      <Stack gap={1}>
        {legends?.map((legend) => (
          <LegendTable
            type={legend[1]?.legendType}
            headers={
              legend[1]?.legendType === 'range'
                ? [
                    intl.formatMessage({ defaultMessage: 'Label' }),
                    intl.formatMessage({ defaultMessage: 'Lower Limit' }),
                    intl.formatMessage({ defaultMessage: 'Upper Limit' })
                  ]
                : [intl.formatMessage({ defaultMessage: 'Label' }), intl.formatMessage({ defaultMessage: 'Value' })]
            }
            data={legend[1]?.legend}
            itemLabel={legend[1]?.itemLabel}
            itemLabelFrench={legend[1]?.itemLabelFrench}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default Legends;
